// extracted by mini-css-extract-plugin
export default {"general-vote-info":"general-vote-info--kECLo","generalVoteInfo":"general-vote-info--kECLo"};